'use strict';
module.exports = function GoogleDriveImportModel(authenticationModel, picker, pageController) {
	this.pickImport = function () {
		return authenticationModel.getProfile().then(function (profile) {
			return picker.pickFileForImport(profile, 'Select or upload a MindMup or a Freemind file');
		}).then(function (file) {
			return pageController.editFileId(file.id);
		});
	};
};
